<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC');
  // /* 导入 NotoSansSC-Black.otf */
  // @font-face {
  //   font-family: 'Noto Sans SC';
  //   src: url('assets/fonts/Noto_Sans_SC/NotoSansSC-Black.otf') format('opentype');
  //   font-weight: 900; /* 设置字体粗细 */
  // }

  // /* 导入 NotoSansSC-Bold.otf */
  // @font-face {
  //   font-family: 'Noto Sans SC';
  //   src: url('assets/fonts/Noto_Sans_SC/NotoSansSC-Bold.otf') format('opentype');
  //   font-weight: 700; /* 设置字体粗细 */
  // }

  // /* 导入 NotoSansSC-Medium.otf */
  // @font-face {
  //   font-family: 'Noto Sans SC';
  //   src: url('assets/fonts/Noto_Sans_SC/NotoSansSC-Medium.otf') format('opentype');
  //   font-weight: 500; /* 设置字体粗细 */
  // }

  // /* 导入 NotoSansSC-Regular.otf */
  // @font-face {
  //   font-family: 'Noto Sans SC';
  //   src: url('assets/fonts/Noto_Sans_SC/NotoSansSC-Regular.otf') format('opentype');
  //   font-weight: 400; /* 设置字体粗细 */
  // }

  // /* 导入 NotoSansSC-Light.otf */
  // @font-face {
  //   font-family: 'Noto Sans SC';
  //   src: url('assets/fonts/Noto_Sans_SC/NotoSansSC-Light.otf') format('opentype');
  //   font-weight: 300; /* 设置字体粗细 */
  // }

  // /* 导入 NotoSansSC-Thin.otf */
  // @font-face {
  //   font-family: 'Noto Sans SC';
  //   src: url('assets/fonts/Noto_Sans_SC/NotoSansSC-Thin.otf') format('opentype');
  //   font-weight: 100; /* 设置字体粗细 */
  // }
  
  #app {
    font-family: Noto Sans SC;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    ul, li{
      list-style: none;
    }
    a{
      text-decoration: none;
    }
  }
  
  .contentflex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  
  .flex {
    display: flex;
  }
  
  .font12 {
    font-size: 12px;
  }
  
  .font16 {
    font-size: 16px;
  }
  
  .font18 {
    font-size: 18px;
  }
  
  .font24 {
    font-size: 24px;
  }
  
  .font26 {
    font-size: 26px;
  }
  
  .font28 {
    font-size: 28px;
  }
  
  .font30 {
    font-size: 30px;
  }
  
  .font36 {
    font-size: 36px;
  }
  
  .color999 {
    color: #999;
  }
  
  .line24 {
    line-height: 24px;
  }
  
  .itemCenter {
    display: flex;
    align-items: center;
  }
  
  .curson {
    cursor: pointer;
  }
  
  .flexbetween {
    display: flex;
    justify-content: space-between;
  }
  
  .flexaround {
    display: flex;
    justify-content: space-around;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue